import { IMAGE_HOSTS, IMAGE_HOST_PATTERNS } from './image-host-allowlist'

/**
 * FRIDGE-1506: whether next/image may optimize this source — a same-origin
 * path with no query string (next.config's localPatterns accept every local
 * path, but only with `search: ''`, so a cache-busting query is refused), or an https
 * host next.config's remotePatterns allow (lib/image-host-allowlist.js, the
 * list it is built from). A source the optimizer would refuse stays a plain
 * <img>, so switching a surface to next/image can never break a photo it
 * shows today.
 */
export function canOptimizeImageSrc(src: string | null | undefined): boolean {
  if (!src) return false
  if (src.startsWith('/') && !src.startsWith('//')) return !src.includes('?')
  let host: string
  try {
    const url = new URL(src)
    if (url.protocol !== 'https:') return false
    host = url.hostname
  } catch {
    return false
  }
  if ((IMAGE_HOSTS as readonly string[]).includes(host)) return true
  return (IMAGE_HOST_PATTERNS as readonly string[]).some((pattern) => pattern.startsWith('**.') && host.endsWith(pattern.slice(2)))
}
